// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Outlet } from 'react-router';
import { type FC, useCallback, useState } from 'react';
import { Disclaimer, NavigationSidebar } from '@client-app/components';
import { Topbar } from './topbar';
import { PortfoliosProvider } from '@shared/ui-kit/providers/portfolios-provider';

const getInitialSidebarOpen = () =>
  typeof window !== 'undefined' && window.innerWidth >= 1280;

export const Layout: FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(getInitialSidebarOpen);
  const openSidebar = useCallback(() => setSidebarOpen(true), []);

  return (
    <PortfoliosProvider>
      <div className="relative z-0 flex min-h-screen flex-row overflow-hidden">
        <NavigationSidebar open={sidebarOpen} onOpenChange={setSidebarOpen} />
        <main className="relative flex flex-1 flex-col overflow-auto">
          <Topbar onOpenSidebar={openSidebar} />
          <Outlet />
        </main>
      </div>
      <Disclaimer />
    </PortfoliosProvider>
  );
};
